<template>
    <div>
      <div id="topNav" v-resize="onResize">
        <div id="topNavWrapper">
          <!--DASHBOARD -->
          <EventMenu
            v-if="
              $route.name == 'eventDetails' ||
              $route.name == 'practice' ||
              $route.name == 'Registration' ||
              $route.name == 'ImportRegistrants' ||
              $route.name == 'DeleteAllRegistrants' ||
              $route.name == 'ValidateAma' ||
              $route.name == 'EventClasses' ||
              $route.name == 'CreateRegistrant' ||
              $route.name == 'CreateClasses' ||
              $route.name == 'EditClasses' ||
              $route.name == 'FormClasses' ||
              $route.name == 'EventBrands' ||
              $route.name == 'ImportBrands' ||
              $route.name == 'StartGrids' ||
              $route.name == 'MyLaps' ||
              $route.name == 'SportTags' ||
              $route.name == 'RaceTimer' ||
              $route.name == 'Westhold' ||
              $route.name == 'LinkedClasses' ||
              $route.name == 'ImportClasses' ||
              $route.name == 'RegistrationSetup' ||
              $route.name == 'WaitList' ||
              $route.name == 'EventRaceList' ||
              $route.name == 'EventRaceImages' ||
              $route.name == 'EventRaceAdvanceSettings' || 
              $route.name == 'Pricing' ||
              $route.name == 'RegisteredSpectator' ||
              $route.name == 'classDivisions'
            "
            @loadTopMenuResponsive="loadTopMenuResponsive" 
          />
          <EventOldSiteMenu
            v-if="$route.name == 'RegisteredSpectatorGlobal' ||
                  $route.name == 'PricingOld' ||
                  $route.name == 'PracticeOld' ||
                  $route.name == 'DivisionsOld'
                 "
            @loadTopMenuResponsive="loadTopMenuResponsive" 
          />
          <ReportOldSiteMenu 
            v-if="$route.name == 'Report' || $route.name == 'Serie'|| $route.name == 'CloneWaiversOld' || 
                  $route.name == 'WaiverCreate' || $route.name == 'MedicalInformation' || $route.name == 'Signed' || 
                  $route.name == 'PromoterEventLink' || $route.name == 'ImportEvent' || $route.name == 'ImportRaces' ||  
                  $route.name == 'PromoterDashboard' || $route.name == 'Workers' || $route.name == 'WorkerCreate' || 
                  $route.name == 'EventList' || $route.name == 'WaiverSign' || 
                  $route.name == 'RaceList' ||
                  $route.name == 'Profile' ||
                  $route.name == 'seriesDashboard' ||
                  $route.name == 'reportsDashboard' ||
                  $route.name == 'SerieDetails' ||
                  $route.name == 'SerieResults' ||
                  $route.name == 'CloneEventsOld' || $route.name == 'TestLayout' || $route.name == 'PaymentManager'" 
            @loadTopMenuResponsive="loadTopMenuResponsive"
          />
          <RaceMenu 
            v-if="
            $route.name == 'raceDetails' ||
            $route.name == 'RaceClassesSetup' || 
            $route.name == 'RaceScoringParameters' ||
            $route.name == 'RaceParticipantsSetup'" 
            @loadTopMenuResponsive="loadTopMenuResponsive" 
          />
          <RaceEditMenu
            v-if="
              $route.name == 'raceEdit' ||
              $route.name == 'NewParticipant' ||
              $route.name == 'ParticipantScores' ||
              $route.name == 'DeleteClassScore' ||
              $route.name == 'Results' ||
              $route.name == 'QuickScore' ||
              $route.name == 'AddDNFParticipants' ||
              $route.name == 'ClearAllScores' ||
              $route.name == 'ImportScoresFromRace' ||
              $route.name == 'PhoneMonitor' ||
              $route.name == 'SectionEditor'
            " @loadTopMenuResponsive="loadTopMenuResponsive"
          />
      
          <!--EVENTS-->
          <!--EVENTS -> RACES-->
          <RaceEditMenuOld 
              v-if="$route.name == 'SectionEditorOld' || $route.name == 'ResultsOld' || $route.name == 'ParticipantScoresOld' || 
                    $route.name == 'CreateBackupRace' || $route.name == 'ScoreAnalysis'"
              @loadTopMenuResponsive="loadTopMenuResponsive" 
          />
          
          <div v-if="$route.name == 'SectionEditor' && false" class="text-center">
            <v-btn small link class="ma-2" href="/admin/promoterDashboard">
              <i class="far fa-tachometer"></i>
              {{ $tc("top-menu.all.dashboard") }}
            </v-btn>
          </div>
  
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapState } from "vuex";
  import EventMenu from "@/components/topmenu/EventMenu.vue";
  import EventOldSiteMenu from "@/components/topmenu/EventOldSiteMenu.vue";
  import RaceEditMenu from "@/components/topmenu/RaceEditMenu.vue";
  import RaceMenu from "@/components/topmenu/RaceMenu.vue";
  import ReportOldSiteMenu from '@/components/topmenu/ReportOldSiteMenu.vue';
  import RaceEditMenuOld from '@/components/topmenu/RaceEditMenuOld.vue';
  //import Title from "@/components/Title.vue";
  
  
  export default {
    components: {
      EventMenu,
      RaceEditMenu,
      RaceMenu,
      EventOldSiteMenu,
      ReportOldSiteMenu,
      RaceEditMenuOld,
      //Title
    },
    data () {
      return {
        itemsR: [],
        eventEmit: null,
        drawerRight: false,
        clipped: false
      };
    },
    computed: {
      ...mapState(["root"]),
    },
    methods: {
      loadEventRace (item) {
        this.eventEmit = item;
      },
      goLink(_name){
        this.$router.push({ name: _name, params: { id: this.$route.params.id }});
      },
      onResize() {
        this.hiddenMenu();
      },
      hiddenMenu() {
        var width = document.getElementsByTagName("BODY")[0].clientWidth;
        if (width < 1263) {
          const topNav = document.getElementById("topNav");
          if(topNav) topNav.style.display = "none";
        } else {
          const topNav = document.getElementById("topNav");
          if(topNav) topNav.style.display = "block";
        }
        this.drawerRight = false;
      },
      responsiveTopMenu(items) {
        this.itemsR = items;
      },
      loadTopMenuResponsive (items) {
        if(this.$route.name == 'RegisteredSpectatorGlobal' || this.$route.name == 'PricingOld' || this.$route.name == 'PracticeOld' || this.$route.name == 'DivisionsOld' || this.$route.name == 'CloneEventsOld' || 
            this.$route.name == 'Report' || this.$route.name == 'Serie'|| this.$route.name == 'CloneWaiversOld' || this.$route.name == 'WaiverCreate' || 
            this.$route.name == 'SectionEditorOld' || this.$route.name == 'ResultsOld' || this.$route.name == 'ParticipantScoresOld' || 
            this.$route.name == 'CreateBackupRace' || this.$route.name == 'ScoreAnalysis' || this.$route.name == 'ImportRaces') {
              this.responsiveTopMenu(items);
          }
        this.$emit("loadTopMenuResponsive", items);
      },
      changePage(path = '', name = '') {
        if(name && name != '') {
          this.$router.push({
            name, params: this.$route.params
          });
          return;
        }
  
        if (path && !path.includes("http") && this.$route.path !== path && path != "") {
          /*this.$router.push({
            path: path,
          });*/
          window.location.href = `${process.env.VUE_APP_ROOT}${path}`;
          return;
        }
        window.location.href = path;
      },
    },
    beforeUpdate() {
      this.hiddenMenu();
    },
    mounted() {
      this.$emit('changeBand', {index: 'bandTopMenuMounted',value: true});
      this.hiddenMenu();
    },
  };
  </script>
  
  <style>
  #topNav {
    text-align: center;
    width: 100%;
    min-height: 35px;
    border-bottom: 2px solid var(--v-accent-lighten1);
    background-color: var(--v-accent-base);
  }
  
  #topNavWrapper {
    display: inline-block;
  }
  
  .topLink a:active,
  a:visited,
  a:link {
    color: var(--v-primary-base);
  }
  
  .eventListWrap a:link,
  a:active,
  a:visited {
    text-decoration: none;
    cursor: pointer;
  }
  
  .topLink {
    float: left;
    padding: 6px 10px;
    text-align: center;
    border: 1px solid var(--v-primary-lighten2);
    background: var(--v-primary-base);
    height: 33px;
    font-weight: normal;
    font-size: 14px;
  }
  
  .topIconOrg {
    padding-top: 0px;
  }
  
  .topIcon {
    float: left;
    padding-left: 5px;
    padding-right: 5px;
  }
  
  #topNav .v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: transparent !important;
    color: var(--v-primary-darken3) !important;
    text-transform: none ;
    font-size: 14px;
  }
  
  /*nav{
        transform: translateX(0%) !important;
  }*/
  
  .tabulator-header-filter input {
      color: black;
  }
  </style>
  